import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

export default function CookieConsent() {
  const [show, setShow] = useState(false);
  useEffect(() => { if (!localStorage.getItem("mpp_cookie_consent")) setShow(true); }, []);
  const choose = (v) => { localStorage.setItem("mpp_cookie_consent", v); setShow(false); };
  if (!show) return null;
  return (
    <div className="fixed inset-x-0 bottom-0 z-[60] p-4 sm:p-5" data-testid="cookie-consent-banner">
      <div className="max-w-5xl mx-auto rounded-2xl p-5 sm:p-6 shadow-2xl flex flex-col sm:flex-row sm:items-center gap-4" style={{ backgroundColor: "#E3FF00" }}>
        <div className="flex-1 text-neutral-900">
          <h3 className="font-display font-bold text-base">Rispettiamo la tua privacy</h3>
          <p className="text-sm mt-1 leading-relaxed text-neutral-900">
            Usiamo cookie tecnici necessari e, con il tuo consenso, cookie per migliorare l'esperienza. Leggi la{" "}
            <Link to="/cookie-policy" className="underline font-semibold">Cookie Policy</Link> e la{" "}
            <Link to="/privacy" className="underline font-semibold">Privacy Policy</Link>.
          </p>
        </div>
        <div className="flex gap-3 shrink-0">
          <button onClick={() => choose("essential")} data-testid="cookie-essential-button" className="px-5 py-2.5 rounded-lg border-2 border-neutral-900 text-neutral-900 font-semibold text-sm hover:bg-neutral-900/10 transition-colors">Solo essenziali</button>
          <button onClick={() => choose("all")} data-testid="cookie-accept-button" className="px-5 py-2.5 rounded-lg bg-neutral-900 text-white font-semibold text-sm hover:bg-neutral-800 transition-colors">Accetta tutti</button>
        </div>
      </div>
    </div>
  );
}
